import type { TMessageKey } from './useTranslate'

import { allMessages } from '@/translations/translations.constants'

export const isMessageKey = (key: string): key is TMessageKey => key in allMessages.fr
